/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Add_Operator_UserInputs */



/**
* | output |
* | --- |
* | "Eclypse Operator User" |
*
* @param {Module_Add_Operator_UserInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_add_operator_user = /** @type {((inputs?: Module_Add_Operator_UserInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Add_Operator_UserInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Eclypse Operator User")
	return /** @type {LocalizedString} */ ("Utilisateur opérateur Eclypse")
});